import { DateTimeString, Employer, IdentifiableBase } from '@ipensii/shared/domain-shared';

export interface EmployeeInfo extends IdentifiableBase {
  name: string;
  email: string;
  phoneNumber: string;
  employerContributionAmount: number;
  lastNotifiedAt?: DateTimeString;
  employerInternalRef?: string;
  employer?: Employer;
  isUserActivated?: boolean;
}

export interface EmployeeInfoWithFundSubscription extends EmployeeInfo {
  onboardingEmployeeContributionAmount?: number;
  onboardingEmployerContributionAmount?: number;
  documentUuid?: number;
  onboardingDatetime?: DateTimeString;
  fundName?: string;
  hasEmployeeFundSubscription?: boolean;

  actualEmployeeContributionAmount?: number;
  actualEmployerContributionAmount?: number;
}

export const NEW_EMPLOYEE_ID = 'new';
